import { cn } from '@/lib/utils';
import type { ReactNode } from 'react';

export function NoticeCard({
  icon: Icon,
  title,
  children,
  action,
  className,
}: {
  icon: React.ComponentType<{ className?: string }>;
  title: string;
  children: ReactNode;
  action?: ReactNode;
  className?: string;
}) {
  return (
    <div className={cn('rounded-xl border border-brand/20 bg-brand-subtle/40 px-4 py-3', className)}>
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex min-w-0 flex-1 items-start gap-3">
          <Icon className="mt-0.5 h-4 w-4 shrink-0 text-brand" />
          <div className="min-w-0">
            <p className="text-sm font-medium text-text-primary">{title}</p>
            <div className="text-[13px] text-text-secondary">{children}</div>
          </div>
        </div>
        {action && <div className="flex shrink-0 items-center justify-end">{action}</div>}
      </div>
    </div>
  );
}
